import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// Seguridad de la cuenta: estado, 2 pasos, PIN, avisos, contraseña, dispositivos, sesiones y actividad. Todo cambio vuelve a leer el estado.
export function useSecurityStatus(enabled = true) {
  return useQuery({
    queryKey: ["security", "status"],
    queryFn: async () => (await apiClient.get("/security/status")).data,
    enabled,
    staleTime: 0,
    retry: false,
  });
}

export function useDevices(enabled = true) {
  return useQuery({
    queryKey: ["security", "devices"],
    queryFn: async () => (await apiClient.get("/security/devices")).data.devices,
    enabled,
    staleTime: 0,
    retry: false,
  });
}

export function useSecurityEvents(enabled = true) {
  return useQuery({
    queryKey: ["security", "events"],
    queryFn: async () => (await apiClient.get("/security/events")).data.events,
    enabled,
    staleTime: 0,
    retry: false,
  });
}

function useSecurityMutation(request) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body) => (await request(body)).data,
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["security"] }),
  });
}

export const useStartTotp = () => useSecurityMutation((body) => apiClient.post("/security/totp/start", body || {}));
export const useConfirmTotp = () => useSecurityMutation((body) => apiClient.post("/security/totp/confirm", body));
export const useDisableTotp = () => useSecurityMutation((body) => apiClient.post("/security/totp/disable", body));
export const useRegenerateCodes = () => useSecurityMutation((body) => apiClient.post("/security/recovery-codes", body));
export const useSetPin = () => useSecurityMutation((body) => apiClient.post("/security/pin", body));
export const useUpdateSecuritySettings = () => useSecurityMutation((body) => apiClient.patch("/security/settings", body));
export const useTestChannel = () => useSecurityMutation((channel) => apiClient.post(`/security/test/${channel}`));
export const useChangePassword = () => useSecurityMutation((body) => apiClient.post("/security/password", body));
export const useRemoveDevice = () => useSecurityMutation((id) => apiClient.delete(`/security/devices/${id}`));
export const useRevokeOtherSessions = () => useSecurityMutation(() => apiClient.post("/security/sessions/revoke-others"));
